import { useState, useEffect } from 'react';

function deviceIsInPortraitMode() {
  const { orientation } = window.screen;
  // Currently Safari, on both iOS and MacOS, have not implemented orientations so
  // thats why we have to do a kind of guess in that case.
  return {
    inPortraitMode: orientation
      ? orientation.angle < 90 && orientation.angle > -90
      : window.innerHeight > window.innerWidth
  };
}

export default function useDeviceOrientation() {
  const [deviceOrientation, setDeviceOrientation] = useState(deviceIsInPortraitMode());

  useEffect(() => {
    function handleResize() {
      setDeviceOrientation(deviceIsInPortraitMode());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return deviceOrientation;
}
